export default "__VITE_ASSET__Dcc3UJTh__"